import React, { useCallback, useMemo, useState } from "react";
import { UserSwitchOutlined } from "@ant-design/icons";
import { Button, Checkbox, Descriptions, Divider } from "antd";
import { connect } from "dva";
import { ShipmentStatus } from "@/utils/enum";
import { formatPhoneNumber } from "@/utils/utils";
import CopyableGUID from "@/components/CopyableGUID";
import ChangeDriverModal from "@/components/LoadActionsButton/ChangeDriverModal";

const TransporterInfoTabPane = ({
  dispatch,
  adminShipmentView,
  isOpsAssistedChecked,
  handleToggleOpsAssisted,
  loadingOpsAssisted,
}) => {
  const [changeDriverModalOpen, setChangeDriverModalOpen] = useState(false);

  const adminShipmentData = useMemo(() => adminShipmentView?.data, [adminShipmentView]);

  const handleClick = useCallback(() => {
    setChangeDriverModalOpen(true);
  }, []);

  if (!adminShipmentData?.load?.transporter) {
    return <p>Shipment not assigned to transporter yet.</p>;
  }

  return (
    <>
      <Descriptions
        title={
          <a
            href={`/admin/transporters/view?transporterId=${adminShipmentData?.load?.transporter?.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {adminShipmentData?.load?.transporter?.name}
          </a>
        }
        column={1}
      >
        <Descriptions.Item key="transporterAddress" style={{ paddingBottom: "0" }}>
          {adminShipmentData?.load?.transporter?.completedAddress}
        </Descriptions.Item>
        <Descriptions.Item key="transporterName" style={{ paddingBottom: "0" }} label="Contact">
          {adminShipmentData?.load?.userFullName}
        </Descriptions.Item>
        <Descriptions.Item key="transporterEmail" style={{ paddingBottom: "0" }} label="Email">
          {adminShipmentData?.load?.userEmail}
        </Descriptions.Item>
        <Descriptions.Item key="transporterPhone" style={{ paddingBottom: "0" }} label="Phone">
          {formatPhoneNumber(adminShipmentData?.load?.userPhoneNumber)}
        </Descriptions.Item>
      </Descriptions>
      <Divider />
      <Descriptions title="Load Info" column={1} style={{ marginBottom: 32 }}>
        <Descriptions.Item key="loadId" label="Load ID">
          <CopyableGUID guid={adminShipmentData?.load?.id} itemStyle={{ marginLeft: 5 }} />
        </Descriptions.Item>
        <Descriptions.Item key="isOpsAssisted" style={{ paddingBottom: "0" }} label="Ops Assisted">
          <Checkbox disabled={loadingOpsAssisted} checked={isOpsAssistedChecked} onChange={handleToggleOpsAssisted} />
        </Descriptions.Item>
      </Descriptions>
      <Button
        icon={<UserSwitchOutlined />}
        type="primary"
        onClick={handleClick}
        // Disabled if status is delivered or further
        disabled={adminShipmentData?.status >= ShipmentStatus.Delivered}
      >
        Change Driver
      </Button>

      <ChangeDriverModal
        visible={changeDriverModalOpen}
        loadData={adminShipmentData?.load}
        refreshPageData={() => {
          dispatch({
            type: "adminShipmentView/fetchSingleAdminShipment",
            shipmentId: adminShipmentData.id,
          });
        }}
        onClose={() => setChangeDriverModalOpen(false)}
      />
    </>
  );
};

export default connect(({ adminShipmentView, loading }) => ({
  adminShipmentView,
  loadingOpsAssisted: loading.effects["adminShipmentView/toggleOpsAssisted"],
}))(TransporterInfoTabPane);
